import React from 'react';
import './AccountSelector.css';

function AccountSelector({ accounts, selectedAccount, onAccountChange }) {
  return (
    <div className="account-selector">
      <h3>Select Account</h3>
      <div className="account-buttons">
        {accounts.map(account => (
          <button
            key={account.id}
            className={`account-button ${selectedAccount?.id === account.id ? 'active' : ''}`}
            onClick={() => onAccountChange(account)}
          >
            <span className="account-name">{account.name}</span>
            <span className="account-id">{account.accountId}</span>
          </button>
        ))}
      </div>
      {accounts.length === 0 && (
        <p className="no-accounts">No accounts configured</p>
      )}
    </div>
  );
}

export default AccountSelector;